import { DialogService } from 'nebula-ui-kit';
import { map, Observable, take } from 'rxjs';
import { VaultReasonConfirmDialogComponent } from './vault-reason-confirm-dialog.component';

export type VaultDialogVariant = 'success' | 'error' | 'warning' | 'info';

export interface VaultConfirmDialogConfig {
  title: string;
  message: string;
  variant?: VaultDialogVariant;
  confirmLabel?: string;
  cancelLabel?: string;
}

export interface VaultAlertDialogConfig {
  title: string;
  message: string;
  variant?: VaultDialogVariant;
}

export interface VaultReasonConfirmDialogConfig extends VaultConfirmDialogConfig {
  reasonLabel?: string;
  reasonPlaceholder?: string;
  requireReason?: boolean;
}

export function openVaultConfirmDialog(
  dialog: DialogService,
  config: VaultConfirmDialogConfig,
): Observable<boolean> {
  return dialog
    .confirm({
      title: config.title,
      message: config.message,
      variant: config.variant ?? 'warning',
      confirmLabel: config.confirmLabel ?? 'Confirmar',
      cancelLabel: config.cancelLabel ?? 'Cancelar',
    })
    .pipe(take(1));
}

export function openVaultAlertDialog(dialog: DialogService, config: VaultAlertDialogConfig): void {
  dialog
    .confirm({
      title: config.title,
      message: config.message,
      variant: config.variant ?? 'info',
      confirmLabel: 'Aceptar',
      cancelLabel: 'Cerrar',
    })
    .pipe(take(1))
    .subscribe();
}

export function openVaultReasonConfirmDialog(
  dialog: DialogService,
  config: VaultReasonConfirmDialogConfig,
): Observable<string | null> {
  const dialogRef = dialog.open(VaultReasonConfirmDialogComponent, {
    size: 'sm',
    data: {
      title: config.title,
      message: config.message,
      type: config.variant ?? 'warning',
      confirmText: config.confirmLabel ?? 'Confirmar',
      cancelText: config.cancelLabel ?? 'Cancelar',
      reasonLabel: config.reasonLabel ?? 'Motivo',
      reasonPlaceholder: config.reasonPlaceholder ?? '',
      requireReason: config.requireReason ?? false,
    },
  });

  return dialogRef.afterClosed().pipe(
    take(1),
    map((result) => (typeof result === 'string' ? result : null)),
  );
}
